import { useState } from 'react';
import { createPortal } from 'react-dom';
import { toast } from 'sonner';
import { Sparkles, Loader2, X, Smartphone } from 'lucide-react';
import { api } from '../lib/api';

const inp = { width: '100%', fontFamily: 'Lexend', fontSize: 12.5, background: 'var(--sf)', border: '1px solid var(--bd)', borderRadius: 8, padding: '7px 10px', color: 'var(--t1)', outline: 'none' };

// Ajoute titres / descriptions / liens Drive d'un doc aux vidéos EXISTANTES du projet.
export default function ProjectPostageDialog({ project, users, onClose, onSaved }) {
  const [text, setText] = useState('');
  const [loading, setLoading] = useState(false);
  const [items, setItems] = useState(null);
  const [videos, setVideos] = useState([]);
  const [posterId, setPosterId] = useState(project.poster_id || '');
  const [saving, setSaving] = useState(false);

  const analyse = async () => {
    if (text.trim().length < 20) { toast.error('Colle le contenu du doc'); return; }
    setLoading(true);
    try {
      const r = await api.post(`/projects/${project.id}/postage/preview`, { text: text.trim() });
      setItems(r.data.items); setVideos(r.data.videos);
      toast.success(`${r.data.items.length} post(s) associé(s)`);
    } catch (e) { toast.error(e?.response?.data?.detail || 'Erreur IA'); }
    finally { setLoading(false); }
  };
  const upd = (i, k, v) => setItems((xs) => xs.map((x, j) => (j === i ? { ...x, [k]: v } : x)));
  const nNew = (items || []).filter((x) => !x.video_id).length;

  const apply = async () => {
    if (nNew && !posterId) { toast.error('Choisis un posteur pour les vidéos en plus'); return; }
    setSaving(true);
    try {
      const r = await api.post(`/projects/${project.id}/postage/apply`, { items, poster_id: posterId || null });
      toast.success(`Postage ajouté ✓ · ${r.data.updated} vidéo(s) mises à jour${r.data.created ? ` · ${r.data.created} créée(s) « À poster »` : ''}`);
      onSaved();
    } catch (e) { toast.error(e?.response?.data?.detail || 'Erreur'); setSaving(false); }
  };

  return createPortal(
    <div data-testid="project-postage-dialog" onClick={onClose} style={{ position: 'fixed', inset: 0, zIndex: 200, background: 'rgba(6,12,26,0.78)', backdropFilter: 'blur(14px)', display: 'grid', placeItems: 'center', padding: 14 }}>
      <div onClick={(e) => e.stopPropagation()} className="scale-in" style={{ width: '100%', maxWidth: 820, maxHeight: '90vh', overflowY: 'auto', borderRadius: 20, padding: 20, background: 'linear-gradient(180deg, rgba(20,29,66,0.92) 0%, rgba(14,22,44,0.98) 100%)', border: '1px solid var(--bd)' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 14 }}>
          <Smartphone size={18} color="#5BBEFC" />
          <div style={{ flex: 1 }}>
            <div style={{ fontFamily: 'Sora', fontWeight: 800, fontSize: 17, color: 'var(--t1)' }}>Ajouter le postage · {project.name}</div>
            <div style={{ fontFamily: 'Lexend', fontSize: 12, color: 'var(--t3)' }}>Colle le doc : l&apos;IA range titre, description et lien Drive dans chaque vidéo du projet.</div>
          </div>
          <button data-testid="project-postage-close" onClick={onClose} style={{ background: 'transparent', border: '1px solid var(--bd)', borderRadius: 9, padding: 7, color: 'var(--t2)', cursor: 'pointer' }}><X size={14} /></button>
        </div>
        {!items ? (
          <>
            <textarea data-testid="project-postage-doc" value={text} onChange={(e) => setText(e.target.value)} rows={12} placeholder="Colle ici le doc (titres, descriptions, liens Drive, dates)…" style={{ ...inp, resize: 'vertical' }} />
            <button data-testid="project-postage-analyse" onClick={analyse} disabled={loading} className="asa-btn asa-btn-primary" style={{ width: '100%', marginTop: 12, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: 8 }}>
              {loading ? <Loader2 size={15} className="spin" /> : <Sparkles size={15} />}{loading ? 'Lecture du doc…' : 'Analyser avec l\'IA'}
            </button>
          </>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
            {nNew > 0 && (
              <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '10px 12px', borderRadius: 12, background: 'rgba(245,197,106,0.08)', border: '1px solid rgba(245,197,106,0.3)' }}>
                <span style={{ flex: 1, fontFamily: 'Lexend', fontSize: 12, color: '#F5C56A' }}>{nNew} post(s) en plus des vidéos du projet → créés direct « À poster »</span>
                <select data-testid="project-postage-poster" value={posterId} onChange={(e) => setPosterId(e.target.value)} style={{ ...inp, width: 200, colorScheme: 'dark' }}>
                  <option value="">— Posteur —</option>
                  {(users || []).filter((u) => !u.is_archived && u.role !== 'client').map((u) => <option key={u.id} value={u.id}>{u.name}</option>)}
                </select>
              </div>
            )}
            {items.map((it, i) => (
              <div key={i} data-testid={`project-postage-item-${i}`} style={{ padding: 12, borderRadius: 12, background: 'var(--sf2)', border: '1.5px solid var(--bd)', display: 'flex', flexDirection: 'column', gap: 6 }}>
                {it.to_check && <span data-testid={`project-postage-check-${i}`} style={{ fontFamily: 'Sora', fontWeight: 800, fontSize: 10.5, color: '#F5C56A' }}>⚠️ À vérifier : l&apos;IA n&apos;est pas sûre de la vidéo</span>}
                <select data-testid={`project-postage-video-${i}`} value={it.video_id || ''} onChange={(e) => { upd(i, 'video_id', e.target.value || null); upd(i, 'to_check', false); }} style={{ ...inp, colorScheme: 'dark', fontWeight: 700, color: it.video_id ? '#5BBEFC' : '#F5C56A' }}>
                  <option value="">➕ Nouvelle vidéo « À poster »</option>
                  {videos.map((v) => <option key={v.id} value={v.id}>{v.title}{v.due_date ? ` · ${v.due_date}` : ''}{v.has_publication ? ' · déjà rempli' : ''}</option>)}
                </select>
                <input data-testid={`project-postage-title-${i}`} value={it.title} onChange={(e) => upd(i, 'title', e.target.value)} placeholder="Titre" style={{ ...inp, fontWeight: 700 }} />
                <textarea data-testid={`project-postage-desc-${i}`} value={it.description || ''} onChange={(e) => upd(i, 'description', e.target.value)} rows={2} placeholder="Description" style={{ ...inp, resize: 'vertical' }} />
                <input data-testid={`project-postage-drive-${i}`} value={it.drive_link || ''} onChange={(e) => upd(i, 'drive_link', e.target.value || null)} placeholder="Lien Drive de la vidéo" style={{ ...inp, color: '#5BBEFC' }} />
              </div>
            ))}
            <div style={{ display: 'flex', gap: 10 }}>
              <button onClick={() => setItems(null)} className="asa-btn asa-btn-ghost">Retour au doc</button>
              <button data-testid="project-postage-apply" onClick={apply} disabled={saving} className="asa-btn asa-btn-primary" style={{ flex: 1 }}>{saving ? 'Enregistrement…' : `Ajouter le postage (${items.length})`}</button>
            </div>
          </div>
        )}
      </div>
    </div>,
    document.body,
  );
}
